import { createContext, useState, useMemo, useContext } from "react";
import PropTypes from "prop-types";
import languages from "locale/translations.js";

const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState("br");

  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);
  };

  // Função que verifica se a chave existe na tradução e retorna um fallback se não existir
  const GetTranslation = (key) => {
    const translation = languages[currentLanguage]?.[key];
    return translation || key || "Tradução não disponível"; // Fallback para tradução não encontrada
  };

  const Values = useMemo(
    () => ({
      currentLanguage,
      changeLanguage,
      GetTranslation
    }),
    [currentLanguage]
  );

  return (
    <LanguageContext.Provider value={Values}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};

export { LanguageProvider };

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error(
      "useLanguage deve ser utilizado dentro de um LanguageProvider"
    );
  }
  return context;
};
